/**
 * Overrides the Chakra Checkbox's internal control square (border-radius, border,
 * checked fill) to match the design spec, scoped to this component via `sx` instead
 * of editing the shared Checkbox theme (which would affect every checkbox in the app).
 */
export const checkboxControlSx = {
  ".chakra-checkbox__control": {
    borderRadius: "5px",
    borderWidth: "1px",
    borderColor: "gray.400",
    background: "white",
    "&[data-checked]": {
      background: "seaGreen.500",
      borderColor: "seaGreen.500",
    },
  },
};

/**
 * Padding/sizing for the Radio/Checkbox itself (not OptionCard's wrapper) so its own
 * <label> — the only element that's actually clickable — fills the entire visual card,
 * padding included. The 15px/16px swap compensates OptionCard's 2px/1px border-width
 * change so the card's overall size doesn't jitter when selection toggles.
 */
export const getOptionControlProps = (isSelected: boolean) => ({
  width: "100%",
  height: "100%",
  padding: isSelected ? "15px" : "16px",
});
